import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./Charges.module.css";
import { Close } from "@mui/icons-material";
import { getCharges } from "../../../../Services/BuySell/Payments";
import { useSelector } from "react-redux";
import {
  consumerCharges,
  generatorCharges,
} from "../../../../Services/Payments/PaymentApi";

const Charges = ({ open, onClose, contractId, userLevel, userType }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  console.debug(data);
  const mainScreenMatchData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection
  );

  const user = useSelector(
    (state) => state?.persistedReducer?.userType
  )?.toLowerCase();

  const id = useSelector(
    (state) =>
      state?.persistedReducer?.user[
        user === "consumer" ? "activeConsumerId" : "activeGeneratorId"
      ]
  );

  const matchedEntry = Array.isArray(mainScreenMatchData)
    ? mainScreenMatchData.find((entry) => entry?.id === contractId)
    : null;

  const fetchCharges = React.useCallback(async () => {
    try {
      if (userLevel) {
        setLoading(true);
        if (user === "consumer") {
          let payload = { consumerIds: [id] };
          let res = await consumerCharges(payload);
          if (res?.data?.code === 200) {
            setData(res?.data?.data?.[0]?.charges);
          }
        }
        if (user === "generator") {
          let payload = { generatorIds: [id] };
          let res = await generatorCharges(payload);
          if (res?.data?.code === 200) {
            setData(res?.data?.data?.[0]?.charges);
          }
        }
      } else {
        setLoading(true);
        const charges = await getCharges(contractId);
        console.debug("charges", charges?.data?.data);
        setData(charges?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching charges:", error);
    } finally {
      setLoading(false);
    }
  }, [contractId, id, user, userLevel]);

  useEffect(() => {
    fetchCharges();
  }, [fetchCharges]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${styles.modalMainChargeSelection}`}>
        <div className="modalHeading">
          <div style={{ color: "var(--fourth-color-text)", fontWeight: 500 }}>
            Charge Finalization
          </div>
          <Close
            onClick={onClose}
            style={{ cursor: "pointer" }}
            alterbutton="false"
          />
        </div>
        <div className={styles.chargeMainElemCont}>
          <div className={`display_flex_row tableHeading`}>
            <div style={{ width: "30%" }}>Charge Name</div>
            <div style={{ width: "10%" }}>Assignee</div>

            <div style={{ width: "15%" }}>Charge Type</div>
            <div style={{ width: "20%" }}>Value</div>
            <div style={{ width: "10%" }}>Type</div>
          </div>

          {!loading && data != null && (
            <div
              style={{ backgroundColor: "#dedfea" }}
              className={` ${styles.chargeHeight}`}
            >
              <div>
                <div
                  style={{ backgroundColor: "#52888f" }}
                  className={"display_flex_row tableDetails"}
                >
                  <div
                    style={{
                      width: "30%",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Self Charges
                  </div>
                </div>

                {data && (
                  <>
                    {" "}
                    {data[
                      user === "consumer"
                        ? "consumerCharges"
                        : "generatorCharges"
                    ]?.length > 0 ? (
                      data[
                        user === "consumer"
                          ? "consumerCharges"
                          : "generatorCharges"
                      ]?.map((ele, index) => (
                        <div
                          className={"display_flex_row tableDetails"}
                          key={index}
                        >
                          <div style={{ width: "30%" }}>{ele?.name || "-"}</div>
                          <div style={{ width: "10%" }}>{"Self"}</div>
                          <div style={{ width: "15%" }}>
                            {ele?.chargeType || "-"}
                          </div>
                          <div
                            style={{ width: "20%" }}
                            className={styles.valueInputCont}
                          >
                            {ele?.value}
                          </div>
                          <div style={{ width: "10%" }}>
                            {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "12px 0",
                        }}
                      >
                        No data
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* counter charges */}
              <div style={{ margin: "10px 0px" }}>
                <div
                  style={{ backgroundColor: "#52888f" }}
                  className={"display_flex_row tableDetails"}
                >
                  <div
                    style={{
                      width: "30%",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Counter Party Charges
                  </div>
                </div>

                {data && (
                  <>
                    {data[
                      user === "consumer"
                        ? "generatorCharges"
                        : "consumerCharges"
                    ]?.length > 0 ? (
                      data[
                        user === "consumer"
                          ? "generatorCharges"
                          : "consumerCharges"
                      ]?.map((ele, index) => {
                        return (
                          <div
                            className={"display_flex_row tableDetails"}
                            key={index}
                          >
                            <div style={{ width: "30%" }}>
                              {ele?.name || "-"}
                            </div>
                            <div
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                              title={
                                matchedEntry?.[
                                  user === "consumer"
                                    ? "capacityGenerator"
                                    : "capacityConsumer"
                                ][
                                  user === "consumer"
                                    ? "generatorName"
                                    : "consumerName"
                                ] || "-"
                              }
                            >
                              {matchedEntry?.[
                                user === "consumer"
                                  ? "capacityGenerator"
                                  : "capacityConsumer"
                              ][
                                user === "consumer"
                                  ? "generatorName"
                                  : "consumerName"
                              ] || "-"}
                            </div>
                            <div style={{ width: "15%" }}>
                              {ele?.chargeType || "-"}
                            </div>
                            <div
                              style={{ width: "20%" }}
                              className={styles.valueInputCont}
                            >
                              {ele?.value}
                            </div>
                            <div style={{ width: "10%" }}>
                              {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "12px 0",
                        }}
                      >
                        No data
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Charges;
